export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Beautiful%20curated%20fashion%20product%20flatlay%20on%20clean%20cream%20background%20featuring%20premium%20white%20sneakers%20alongside%20folded%20beige%20hoodie%20and%20tan%20leather%20crossbody%20bag%20with%20minimal%20gold%20accessories%20scattered%20on%20linen%20fabric%20soft%20diffused%20natural%20window%20light%20editorial%20product%20photography%20high%20end%20aesthetic%20warm%20neutral%20tones%20harmonious%20composition&width=1600&height=900&seq=hero-superbuy-v2&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 container-custom text-center w-full">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 text-background-50 text-xs font-medium mb-6">
            <i className="ri-sparkling-line text-sm"></i>
            <span>Updated 2026 Resources</span>
            <span className="w-1 h-1 rounded-full bg-accent-400"></span>
            <span>Independent Research Platform</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
            The Ultimate <span className="text-primary-400">Superbuy Spreadsheet</span> Resource Hub
          </h1>

          <p className="text-background-100/80 text-base md:text-lg leading-relaxed mb-8 max-w-2xl mx-auto">
            Find, organize, and compare products faster with our complete Superbuy Spreadsheet guides, comparison tools, research tutorials, and expert shopping resources.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#guides"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
            >
              Explore Superbuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-sm hover:bg-background-50/20 transition-all cursor-pointer whitespace-nowrap"
            >
              Visit Our Main Website
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-10 text-background-100/60 text-xs">
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400 text-sm"></i>
              Updated 2026 Resources
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400 text-sm"></i>
              Independent Research Platform
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400 text-sm"></i>
              Beginner Friendly Guides
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400 text-sm"></i>
              Detailed Comparison Tables
            </span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a href="#categories" className="text-background-50/50 hover:text-background-50 transition-colors cursor-pointer">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}